// Generated types for SysMLFeature
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { SysMLTypeReadAPI, SysMLTypeWriteAPI } from './sysmltype';
import { SysMLTypeReadAPISchemaObject, SysMLTypeWriteAPISchemaObject } from './sysmltype';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface SysMLFeatureReadAPI extends SysMLTypeReadAPI {
  /** Direction of feature (in, out, inout) */
  direction?: string | null;
  /** Whether feature is ordered */
  is_ordered?: boolean;
  /** Whether feature values are unique */
  is_unique?: boolean;
}

export interface SysMLFeatureWriteAPI extends SysMLTypeWriteAPI {
  /** Direction of feature (in, out, inout) */
  direction?: string | null;
  /** Whether feature is ordered */
  is_ordered?: boolean;
  /** Whether feature values are unique */
  is_unique?: boolean;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const SysMLFeatureReadAPISchemaObject = SysMLTypeReadAPISchemaObject.extend({
  direction: z.string().nullable().optional(),
  is_ordered: z.boolean().optional(),
  is_unique: z.boolean().optional(),
}).passthrough();
export const SysMLFeatureReadAPISchema: z.ZodType<SysMLFeatureReadAPI> = SysMLFeatureReadAPISchemaObject;

export const SysMLFeatureWriteAPISchemaObject = SysMLTypeWriteAPISchemaObject.extend({
  direction: z.string().nullable().optional(),
  is_ordered: z.boolean().optional(),
  is_unique: z.boolean().optional(),
}).passthrough();
export const SysMLFeatureWriteAPISchema: z.ZodType<SysMLFeatureWriteAPI> = SysMLFeatureWriteAPISchemaObject;
